import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import UAI from "../UAI"
import Loading from "../Utils/Loading"
import "./../Folleto/FolletoWeb.css"
import logoUAI from "../img/LogoUAI-black.png"
import log from "loglevel"
import { GoogleCalendar, ICalendar, OutlookCalendar } from "datebook"
import { FaMobileAlt } from "react-icons/fa"
import { SiGooglecalendar, SiMicrosoftoutlook } from "react-icons/si"
import { Button, Row, Col, Container } from "react-bootstrap"

const AddToCalendar = () => {
  const [cohorte, setCohorte] = useState(null)
  const [calendars, setCalendars] = useState(null)
  const params = useParams()

  useEffect(() => {
    if (!params.nombrecorto) {
      return
    }
    UAI.obtieneConfiguracionInicial(
      () => {
        UAI.obtieneCohortesPorNombreCorto(
          params.nombrecorto,
          [
            "GradoId",
            "FacultadId",
            "nombre",
            "fecha_inicio",
            "objetivo",
            "publicoobjetivo",
            "objetivos_especificos",
            "sigla",
            "contenidos_detallados",
            "NombreCoordinadorAdmision",
            "TelefonoCoordinadorAdmision",
            "EmailCoordinadorAdmision",
            "url_reunion_online",
            "password_reunion_online",
            "sede",
            "Lugar",
            "calendario",
          ],
          (result) => {
            log.debug(result)
            let cohorte = result[0]
            cohorte = UAI.completaAtributosCohorte(
              UAI.creaCohorteRespuestaPostula(cohorte),
              new Date().getFullYear()
            )

            const location =
              cohorte.url_reunion_online &&
              cohorte.url_reunion_online.length > 3
                ? cohorte.url_reunion_online
                : cohorte.sede
            let date = JSON.parse(cohorte.calendario) || {}
            date = Array.isArray(date) ? date[0] : undefined
            let start = date
              ? new Date(date.fecha + "T" + date.start + ":00")
              : undefined
            let end = date
              ? new Date(date.fecha + "T" + date.end + ":00")
              : undefined

            const config = date
              ? {
                  title: "Charla UAI:" + cohorte.nombre,
                  location: location,
                  description: cohorte.objetivo,
                  start: start,
                  end: end,
                  attendees: [],
                }
              : undefined

            let google = config ? new GoogleCalendar(config) : undefined
            let outlook = config ? new OutlookCalendar(config) : undefined
            let icalendar = config ? new ICalendar(config) : undefined

            log.debug(cohorte)
            setCohorte(cohorte)
            if (cohorte.GradoId !== 7 && cohorte.GradoId !== 8) {
              icalendar = undefined
            }
            setCalendars({
              google: google,
              outlook: outlook,
              ical: icalendar,
              start: start,
              end: end,
            })
          },
          (error) => {
            log.error(error)
          }
        )
      },
      (error) => {
        log.error(error)
      }
    )
  }, [params.nombrecorto])

  if (!cohorte || !calendars) {
    return (
      <div
        className="loading-folleto"
        style={{ backgroundImage: `url(${logoUAI})` }}
      >
        <Loading size={25} />
      </div>
    )
  }

  return (
    <Container>
      <Row>
        <Col className="text-center h2 text-white">
          <img src={logoUAI} />
        </Col>
      </Row>
      <Row>
        <Col className="text-center h2 text-white">
          {UAI.nombresGrados[cohorte.GradoId]}
          <br />
          {cohorte.nombre}
          {calendars.start && (
            <>
              <br />
              Fecha: {calendars.start.toLocaleDateString("es-CL")}
            </>
          )}
        </Col>
      </Row>
      {!calendars.ical && (
        <Row>
          <Col className="text-center h4 text-white">
            Este programa no tiene un calendario detallado que permita crear un
            botón de agendar.
          </Col>
        </Row>
      )}
      {calendars.ical && (
        <Row>
          <Col className="text-center">
            <ul>
              <li className="mb-1">
                <Button
                  onClick={() => {
                    window.location.href = calendars.google.render()
                  }}
                >
                  <SiGooglecalendar style={{ marginRight: "1em" }} />
                  Agendar en Google
                </Button>
              </li>
              <li className="mb-1">
                <Button
                  onClick={() => {
                    window.location.href = calendars.outlook.render()
                  }}
                >
                  <SiMicrosoftoutlook style={{ marginRight: "1em" }} />
                  Agendar en Outlook
                </Button>
              </li>
              <li>
                <Button
                  onClick={() => {
                    calendars.ical.download()
                  }}
                >
                  <FaMobileAlt style={{ marginRight: "1em" }} /> Agendar en
                  iPhone o Android
                </Button>
              </li>
            </ul>
          </Col>
        </Row>
      )}
    </Container>
  )
}
export default AddToCalendar
